<template>
    <modal-ui
        :id="id"
        size="modal-sm"
        :title="$t('humans.sendToHikvision')">
        <form class="loader" @submit.prevent="send">
            <loader-ui :is-show="state.loader" />

            <div class="mb-3">
                <label class="form-label w-100">
                    Рисунок студента
                </label>
                <input
                    class="form-control"
                    type="file"
                    accept="image/*"
                    @change="onFileSelected"
                >
                <div v-if="state.error" class="text-danger mt-2">
                    {{ state.error }}
                </div>
            </div>

            <div v-if="state.preview" class="mb-3">
                <img :src="state.preview" class="w-100 border rounded" alt="preview">
            </div>

            <div class="text-center">
                <button-ui button-class="btn-primary" :disabled="!state.preview || state.loader">
                    {{ $t('humans.sendToHikvision') }}
                </button-ui>
            </div>
        </form>
    </modal-ui>
</template>

<script lang="ts">
import { defineComponent, onMounted, reactive } from "vue";
import { useModal } from "@/composables/useModal";
import api from "@/api";

export default defineComponent({
    name: "HikvisionFaceModal",
    props: {
        id: {
            type: String,
            default: '',
        },
    },
    setup(props) {
        const modal = useModal(props.id);

        const state = reactive({
            mode: 'add' as 'add' | 'update',
            humanId: 0,
            loader: false,
            preview: '' as string,
            error: '' as string,
        });

        onMounted(() => {
            state.mode = modal.data.mode || 'add';
            state.humanId = Number(modal.data.humanId || 0);
        });

        function onFileSelected(e: Event) {
            state.error = '';
            const input = e.target as HTMLInputElement;
            const file = input.files?.[0];
            if (!file) {
                state.preview = '';
                return;
            }

            const maxBytes = 2 * 1024 * 1024; // 2MB
            if (file.size > maxBytes) {
                state.error = 'Максимальный размер файла: 2MB';
                state.preview = '';
                input.value = '';
                return;
            }

            const reader = new FileReader();
            reader.onload = () => {
                state.preview = String(reader.result || '');
            };
            reader.onerror = () => {
                state.error = 'Не удалось прочитать файл';
                state.preview = '';
            };
            reader.readAsDataURL(file);
        }

        async function send() {
            if (!state.humanId) {
                state.error = 'Не задан humanId';
                return;
            }
            if (!state.preview) {
                state.error = 'Выберите изображение';
                return;
            }

            state.loader = true;
            state.error = '';
            try {
                const r: any = await api.v1.humans.hikvisionUserSync(state.humanId, state.preview);
                modal.ok({
                    human: r?.data?.data?.human || null,
                    raw: r?.data,
                });
            } catch (e: any) {
                state.error = e?.response?.data?.message || 'Ошибка отправки';
            } finally {
                state.loader = false;
            }
        }

        return {
            state,
            onFileSelected,
            send,
        };
    },
});
</script>

<style scoped lang="scss">
</style>

